/**
 * JIRITSU × AESOP — Scroll Animations
 * GSAP + ScrollTrigger: refined, editorial, never flashy.
 */
(function initAesopAnimations() {
  function boot() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(boot, 80);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Respect reduced-motion preference
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    // ── Hero: subtle parallax on slide images ──
    document.querySelectorAll('.slide__image, .slideshow-section .background-image-container img').forEach(img => {
      const section = img.closest('.slideshow-section') || img.parentElement;
      gsap.fromTo(img,
        { yPercent: -8 },
        {
          yPercent: 8,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.8
          }
        }
      );
    });

    // ── Header: elegant fade in on load ──
    gsap.fromTo('header',
      { opacity: 0 },
      { opacity: 1, duration: 0.9, ease: 'power2.out', delay: 0.15 }
    );

    // ── Homepage: whole-section fade-up reveal as you scroll ──
    // Targets every top-level homepage section (story/editorial panels, full-width
    // image breaks, spacers) and fades + lifts it into place once. Skips the top
    // hero section since it already has its own parallax treatment above and is
    // visible on load anyway (nothing to "reveal").
    const homepageMain = document.querySelector('main[data-template="index"]');
    if (homepageMain) {
      Array.from(homepageMain.children)
        .filter(el => el.classList && el.classList.contains('shopify-section'))
        .forEach(section => {
          if (section.querySelector('[class*="ai-hero-carousel"], .slideshow-section')) return;
          gsap.fromTo(section,
            { opacity: 0, y: 44 },
            {
              opacity: 1,
              y: 0,
              duration: 1,
              ease: 'power2.out',
              scrollTrigger: { trigger: section, start: 'top 88%', once: true }
            }
          );
        });
    }

    // ── Section headings: slow, confident reveal ──
    document.querySelectorAll(
      '.shopify-section h1, .shopify-section h2, .section h2, .section h3, .main-collection-grid__title'
    ).forEach(el => {
      if (el.closest('.slideshow-section')) return; // skip hero
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 1.1,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        }
      );
    });

    // ── Product grids: staggered fade up ──
    document.querySelectorAll('.product-grid, .resource-list--grid').forEach(grid => {
      const items = grid.querySelectorAll('.product-grid__item, .resource-list__item');
      if (!items.length) return;
      gsap.fromTo(items,
        { opacity: 0, y: 36 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          stagger: { amount: 0.5, from: 'start' },
          scrollTrigger: {
            trigger: grid,
            start: 'top 82%',
            once: true
          }
        }
      );
    });

    // ── Editorial text blocks: quiet fade in ──
    document.querySelectorAll('.text-block p').forEach((el, i) => {
      gsap.fromTo(el,
        { opacity: 0, y: 18 },
        {
          opacity: 1,
          y: 0,
          duration: 0.85,
          delay: (i % 3) * 0.06,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 90%', once: true }
        }
      );
    });

    // ── Collection cards: subtle parallax on images ──
    document.querySelectorAll('.collection-card__image img, .featured-blog-posts-card__image img').forEach(img => {
      const card = img.closest('.collection-card, .featured-blog-posts-card');
      if (!card) return;
      gsap.fromTo(img,
        { yPercent: -5 },
        {
          yPercent: 5,
          ease: 'none',
          scrollTrigger: { trigger: card, start: 'top bottom', end: 'bottom top', scrub: 1 }
        }
      );
    });

    // ── Footer: gentle reveal ──
    const footer = document.querySelector('footer');
    if (footer) {
      gsap.fromTo(footer,
        { opacity: 0 },
        {
          opacity: 1, duration: 1.0, ease: 'power2.out',
          scrollTrigger: { trigger: footer, start: 'top 92%', once: true }
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
